import React, { Component } from 'react'
import { Body } from '../Shell/Shell'
import { BASE_URL, GET_AVAILABLE_LISTS } from '../../requests'
import { Link } from 'react-router-dom'
import './Lists.scss'

const MONTH_INDEX = process.env.LISTS_CURRENT_YEAR_MONTH_INDEX ? process.env.LISTS_CURRENT_YEAR_MONTH_INDEX : 7;
const CURRENT_YEAR =  (new Date().getMonth() > MONTH_INDEX) ? (new Date().getFullYear() + 1) : (new Date().getFullYear())
const LISTS_FETCH_AVAILABLE_LISTS = process.env.LISTS_FETCH_AVAILABLE_LISTS

export default class Lists extends Component {
  state = {
    listGroups: [],
    loading: LISTS_FETCH_AVAILABLE_LISTS || false
  }
  componentDidMount = () => {
    if (LISTS_FETCH_AVAILABLE_LISTS) {
      this.getAvailableLists()
    }
  }
  getAvailableLists = () => {
    this.setState({
      loading: true
    })
    GET_AVAILABLE_LISTS(
      listGroups => {
        this.setState({
          listGroups,
          loading: false
        })
      },
      err => {
        console.error(err)
        this.setState({ loading: false })
      }
    )
  }
  render() {
    return (
      <Body>
        <h1 className="page-title">Lists</h1>
          <div className="lists-page">
        {
          !process.env.HIDE_REGISTERED_AGENT_LIST &&
            <ListWrapper title="Registered Agents">
              <ul>              
                {process.env.STATE_ABBR == 'ID' ? (
                  <div>
                    <li>
                      <a href={BASE_URL + '/api/report/FromActiveReport/0/RARecentlyAppointed/0'}>
                        Recently Appointed Registered Agents
                      </a>
                    </li>
                  </div>
                ) : 
                <li>
                  <a href={BASE_URL + '/api/report/FromActiveReport/0/Agents/0'}>
                    List of Commercial Registered Agents
                  </a>
                </li>}
              </ul>
            </ListWrapper>
        }
        {!this.state.loading
          ? this.state.listGroups.map((group, i) => (
              <ListWrapper title={group.label} key={i}>
                <ul>
                  {group.lists.map((list, k) => (
                    <li key={k}>
                      <Link to={list.path}>{list.label}</Link>
                    </li>
                  ))}
                </ul>
              </ListWrapper>
            ))
          : null}
        {/* {process.env.STATE_ABBR == "ND" ? (
          <ListWrapper title="Home Inspectors">
            <ul>
              <li>
                <a
                  href={
                    BASE_URL + "/api/report/FromActiveReport/0/HomeInspectors/0"
                  }
                >
                  List of Registered Home Inspectors
                </a>
              </li>
            </ul>
          </ListWrapper>
        ) : null} */}
        {process.env.STATE_ABBR == 'ND' ? (
          <ListWrapper title="Lobbyists">
            <ul>
              {Array(5)
                .fill(0)
                .map((_, i) => (
                  <li key={i}>
                    <Link to={`lists/lobbyist?year=${CURRENT_YEAR - 5 + i}`}>
                      List of Registered Lobbyists {CURRENT_YEAR - 5 + i}-{CURRENT_YEAR - 4 + i}
                    </Link>
                  </li>
                ))}
            </ul>
          </ListWrapper>
        ) : null}
        
          </div>
      </Body>
    )
  }
}

const ListWrapper = ({ title, children }) => (
  <div className="list-wrapper">
    <h2>{title}</h2>
    {children}
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Lists/Lists.js